import ReactDragResize from './components/ReactDragResize/ReactDragResize'

export default ReactDragResize
